import { PayloadAction } from '@reduxjs/toolkit';
import { initialState } from '.';

export const reducers = {
  setLimit(state, action: PayloadAction<number>) {
    state.limit = action.payload;
  },
  setSkip(state, action: PayloadAction<number>) {
    state.skip = action.payload;
  },
  setPage(state, action: PayloadAction<number>) {
    state.page = action.payload;
  },
  setTotalPages(state, action: PayloadAction<number>) {
    state.totalPages = action.payload;
  },
  setDefaultPagination(state) {
    state.limit = initialState.limit;
    state.skip = initialState.skip;
    state.page = initialState.page;
    state.totalPages = initialState.totalPages;
  },
};
